// FeedbackPopup.jsx
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from "@fortawesome/free-regular-svg-icons";
import CommentPopup from "./CommentPopup";

import confetticorrect from '../imagesHome/confetticorrect.png';
import firecorrect from '../imagesHome/firecorrect.png';

import './FeedbackPopup.css';

const FeedbackPopup = ({
  status,
  onContinue,
  onShowAnswer,
  chapterId,
  lessonId,
  questionIndex,
  messageCorrect,   // “Corect!” sau “5 la rând! +20 XP”
  isStreakBonus,    // TRUE dacă streak == 5
   xpAmount
}) => {

  // 🔥 Înlocuiește confetti cu flame dacă este streak bonus
  const correctIcon = isStreakBonus ? firecorrect : confetticorrect;

  const [isVisible, setIsVisible] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [showXp, setShowXp] = useState(false);

  // 🔥 Pornește animația XP doar pentru +10XP (NU pentru streak)
 // 🔥 Pornește animația XP la ORICE răspuns corect (10 sau 20)
  useEffect(() => {
    if (status === "correct") {
      const timer = setTimeout(() => {
        setShowXp(true);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setShowXp(false);
    }
  }, [status]);


  // 🔥 Număr comentarii
  const [commentCount, setCommentCount] = useState(0);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${apiUrl}/comments/${chapterId}/${lessonId}/${questionIndex}`, {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setCommentCount(data.length))
      .catch(err => console.error("Eroare încărcare nr. comentarii:", err));
  }, [chapterId, lessonId, questionIndex, apiUrl, showComments]);


  // 🔥 mesaje pentru răspuns greșit
  const mesajGresit = [
    "😬 Aproape...", "🔁 Incearca din nou", "❌ Raspuns gresit", "🤔 Mai gandeste-te putin!",
    "💪 Nu renunta!", "🙂 E ok sa gresesti", "🚀 Hai ca poti mai bine!", "😓 Ups! Nu e răspunsul corect",
    "🌈 Poate data viitoare!", "🧠 Gandeste-te inca o data!", "📚 Inca un pas spre invatare!"
  ];

  const wrongMessage = mesajGresit[Math.floor(Math.random() * mesajGresit.length)];

  // Animare intrare popup
  useEffect(() => {
    const t = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      {/* Popup comentarii */}
      {showComments && (
        <CommentPopup
          onClose={() => setShowComments(false)}
          chapterId={chapterId}
          lessonId={lessonId}
          questionIndex={questionIndex}
          onNewComment={() => setCommentCount(prev => prev + 1)}
        />
      )}

      {/* Popup feedback */}
      <div className={`feedback-popup ${isVisible ? 'show' : ''} ${status}`}>
        <div className="feedback-message">

          {/* 📱 PHONE VIEW */}
          <div className="feedback-message-row-phone">

            {status === "incorrect" && (
              <p className="feedback-text">{wrongMessage}</p>
            )}

            {/* CORECT → XP + mesaj pentru mobil */}
            <div className='invisible-feedback-desktop'>
              {status === "correct" && (
                <div className="correct-wrapper-mobile">
                  <div className='align-correct-confetti'>
                    <img src={correctIcon} />
                    <p className="correct-text">{messageCorrect}</p>
                  </div>

                  {/* XP animat doar la +10 XP */}
 <div className="xp-slot">
  {showXp && (
    <div className="xp-float">+{xpAmount} XP</div>
  )}
</div>


                </div>
              )}
            </div>

            <div className="feedback-flag-icon" onClick={() => setShowComments(true)}>
              <FontAwesomeIcon icon={faComment} />
              <div className="text-comment">{commentCount}</div>
            </div>
          </div>


          {/* 🖥️ DESKTOP VIEW */}
          <div className="feedback-actions">

            {status === "incorrect" && (
              <p className="feedback-text-desktop">{wrongMessage}</p>
            )}

            {/* CORECT DESKTOP */}
            <div className='invisible-feedback-phone'>
              {status === "correct" && (
                <div className="correct-wrapper-desktop">
                  <div className='align-correct-confetti'>
                    <img src={correctIcon} />
                    <p className="correct-text-desktop">{messageCorrect}</p>
                  </div>

 <div className="xp-slot">
  {showXp && (
    <div className="xp-float">+{xpAmount} XP</div>
  )}
</div>


                </div>
              )}
            </div>

            {status !== "correct" && (
              <button onClick={onShowAnswer} className="btn-why">De ce?</button>
            )}
            <button
              onClick={onContinue}
              className={status === "correct" ? "btn-continua-feedback" : "btn-danger"}
            >
              Continua
            </button>

            <div className="feedback-flag-icon-desktop" onClick={() => setShowComments(true)}>
              <FontAwesomeIcon icon={faComment} />
              <div className="text-comment">{commentCount}</div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default FeedbackPopup;
